import { service } from '@ember/service';
import type { ValidatorMap } from 'ember-changeset/types';
import type { IntlService } from 'ember-intl';
import CrudJournalEventBaseComponent from 'parog-web/components/forc/abstract/crud-journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import StoolsNumberDeclaredJournalEvent from 'parog-web/models/stools-number-declared-journal-event';
import formatNumberAsString from 'parog-web/utils/format-number-as-string';

export default class StoolsNumberEditionFormComponent extends CrudJournalEventBaseComponent<StoolsNumberDeclaredJournalEvent> {
  static override forcDisplayName = 'Nombre de selles';
  static override fullComponentId = 'stools-number/edition-form';
  static override journalEventClass = StoolsNumberDeclaredJournalEvent;

  /** @type { import("ember-cli-flash/services/flash-messages").default } */
  @service override flashMessages;
  @service declare intl: IntlService;
  /** @type { import("core/services/session").default } */
  @service session;

  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceJournalEvent;

  override get toastMessage() {
    return this.session.patient
      ? {
          message: 'Votre mesure a bien été prise en compte.',
          title: 'Nombre de selles'
        }
      : super.toastMessage;
  }

  override get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  override async save(): Promise<void> {
    this.changeset.set(
      'value',
      formatNumberAsString(this.changeset.get('value'))
    );

    await super.save();
    this.analytics.trackPatientMeasurement('stools-number');
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        <div class='two fields'>
          <div class='field'>
            <Form.Date
              @labelName='Date de la mesure'
              @propertyName='occurredAt'
            />
          </div>
          <div class='field'>
            <Form.NumberInput
              @labelName='Nombre de selles'
              @propertyName='value'
              @min='0'
            />
          </div>
        </div>
        <div class='field'>
          <Form.TextArea @labelName='Commentaires' @propertyName='comments' />
        </div>
      </:content>
    </Provider>
  </template>
}
